import {
  ArrowRight,
  Check,
  ChevronRight,
  CirclePlus,
  createIcons,
  Download,
  Ellipsis,
  Eye,
  FolderDot,
  Image,
  Images,
  Info,
  Key,
  KeyRound,
  Layers,
  LayoutGrid,
  Lock,
  LogIn,
  LogOut,
  Moon,
  Plus,
  ShieldCheck,
  Sun,
  Trash2,
  User,
  UserPlus,
  X,
} from 'lucide';

const icons = {
  ArrowRight,
  Check,
  ChevronRight,
  CirclePlus,
  Download,
  Ellipsis,
  Eye,
  FolderDot,
  Image,
  Images,
  Info,
  Key,
  KeyRound,
  Layers,
  LayoutGrid,
  Lock,
  LogIn,
  LogOut,
  Moon,
  Plus,
  ShieldCheck,
  Sun,
  Trash2,
  User,
  UserPlus,
  X,
};

export type LucideIconName =
  | 'arrow-right'
  | 'check'
  | 'chevron-right'
  | 'circle-plus'
  | 'download'
  | 'ellipsis'
  | 'eye'
  | 'folder-dot'
  | 'image'
  | 'images'
  | 'info'
  | 'key'
  | 'key-round'
  | 'layers'
  | 'layout-grid'
  | 'lock'
  | 'log-in'
  | 'log-out'
  | 'moon'
  | 'plus'
  | 'shield-check'
  | 'sun'
  | 'trash-2'
  | 'user'
  | 'user-plus'
  | 'x';

export const refreshIcons = (root: Document | Element | DocumentFragment = document): void => {
  createIcons({
    icons,
    nameAttr: 'data-lucide',
    attrs: {
      'aria-hidden': 'true',
      'stroke-width': '2',
    },
    root,
  });
};

export const setIcon = (element: HTMLElement, name: LucideIconName): void => {
  const icon = document.createElement('i');
  icon.setAttribute('data-lucide', name);
  icon.setAttribute('aria-hidden', 'true');
  if (element.id) {
    icon.id = element.id;
  }
  const parent = element.parentElement;
  element.replaceWith(icon);
  refreshIcons(parent ?? document);
};
